import React from 'react';

import {
  BOUserTypeEnum,
  FullBOUserResponseModel,
} from 'api/backofficeApiClient';
import CompanyGeneralInfo from './CompanyGeneralInfo';
import SelfEmployedGeneralInfo from './SelfEmployedGeneralInfo';
import InternationalGeneralInfo from './InternationalGeneralInfo';

type Props = {
  profile: FullBOUserResponseModel;
  loadFullProfile: () => Promise<void>;
};

export default function GeneralInfo(props: Props) {
  const { profile, loadFullProfile } = props;
  const { boUserType } = profile;

  const getGeneralInfoByUserEntity = () => {
    const generalInfoProps = {
      generalInfo: profile,
      onEdit: loadFullProfile,
    };

    switch (boUserType) {
      case BOUserTypeEnum.Company:
        return <CompanyGeneralInfo {...generalInfoProps} />;
      case BOUserTypeEnum.SelfEmployed:
        return <SelfEmployedGeneralInfo {...generalInfoProps} />;
      case BOUserTypeEnum.International:
        return <InternationalGeneralInfo {...generalInfoProps} />;

      default:
        return null;
    }
  };

  return <>{getGeneralInfoByUserEntity()}</>;
}
